// extracted by mini-css-extract-plugin
module.exports = {"block":"footer_block__3fWbM","social":"footer_social__2G_bM","link":"footer_link__26DHi","copyright":"footer_copyright__3YWkL","contacts":"footer_contacts__1AcXl"};